//jQuery Scrollstop Plugin v1.2.0
!function(factory){"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof exports?module.exports=factory(require("jquery")):factory(jQuery)}(function($){var dispatch=$.event.dispatch||$.event.handle,special=$.event.special,uid1="D"+ +new Date,uid2="D"+(+new Date+1);special.scrollstart={setup:function(data){var timer,_data=$.extend({latency:special.scrollstop.latency},data),handler=function(evt){var _self=this,_args=arguments;timer?clearTimeout(timer):(evt.type="scrollstart",dispatch.apply(_self,_args)),timer=setTimeout(function(){timer=null},_data.latency)};$(this).bind("scroll",handler).data(uid1,handler)},teardown:function(){$(this).unbind("scroll",$(this).data(uid1))}},special.scrollstop={latency:250,setup:function(data){var timer,_data=$.extend({latency:special.scrollstop.latency},data),handler=function(evt){var _self=this,_args=arguments;timer&&clearTimeout(timer),timer=setTimeout(function(){timer=null,evt.type="scrollstop",dispatch.apply(_self,_args)},_data.latency)};$(this).bind("scroll",handler).data(uid2,handler)},teardown:function(){$(this).unbind("scroll",$(this).data(uid2))}}});

;(function($) {
    var _htOsInfo = jindo.m.getOsInfo(),
        _nVersion = parseInt(_htOsInfo.version, 10);
    $.fn.rwdImageMaps = function(callback) {
        var $img = this;

        var rwdImageMap = function() {
            $img.each(function() {
                if (typeof($(this).attr('usemap')) == 'undefined')
                    return;

                var that = this,
                    $that = $(that);

                $('<img />').load(function() {
                    var attrW = 'width',
                        attrH = 'height',
                        w = $that.attr(attrW),
                        h = $that.attr(attrH);

                    if (!w || !h) {
                        var temp = new Image();
                        temp.src = $that.attr('src');
                        if (!w)
                            w = temp.width || this.width || this.naturalWidth;
                        if (!h)
                            h = temp.height || this.height || this.naturalHeight;
                    }

                    var wPercent = $that.width()/100,
                        hPercent = $that.height()/100,
                        map = $that.attr('usemap').replace('#', ''),
                        c = 'coords';

                    $('map[name="' + map + '"]').find('area').each(function() {
                        var $this = $(this);
                        if (!$this.data(c))
                            $this.data(c, $this.attr(c));

                        var coords = $this.data(c).split(','),
                            coordsPercent = new Array(coords.length);

                        for (var i = 0; i < coordsPercent.length; ++i) {
                            if (i % 2 === 0){
                                coordsPercent[i] = parseInt(((coords[i]/w)*100)*wPercent, 10);
                            }else{
                                coordsPercent[i] = parseInt(((coords[i]/h)*100)*hPercent, 10);
                            }
                        }

                        $this.attr(c, coordsPercent.toString());
                        $img.data('rwdImage', 'T');
                        if(_htOsInfo.android && _nVersion < 3){
                            $img.css('textIndent', '1px');
                        }
                    });

                    if (typeof callback == 'function') {
                        callback.call(this);
                    }

                }).attr('src', $that.attr('src'));
            });
        };

        setTimeout(function(){
            rwdImageMap();
        }, 50);

        return this;
    };
})(jQuery);

var ssg = ssg || {};
ssg.View = ssg.View || {};
ssg.View.responsiveImgMap = ssg.View.responsiveImgMap || {};

ssg.View.responsiveImgMap = function(htOptions){
    $.extend(this, htOptions || {});
    this.init();
};
ssg.View.responsiveImgMap.prototype = {
    sMapImg: '.resmap',
    _bDebug: false,
    _sOrientation: '',
    _nHeight: 0,
    htRatio:{
        landscape: 1,
        portrait: 2
    },
    init: function(){
        this._bDebug = this._checkHashParameter('resmap');
        this._assignElements();
        this._attachEventHandlers();
        this._initVars();
        this._checkOrientation();
        this._checkViewport();
    },
    _assignElements: function(){
        this._window = $(window);
        this._welImage = $(this.sMapImg);
    },
    _attachEventHandlers: function(){
        this._window.on('scrollstop', $.proxy(this._onScrollStop, this));
        jindo.m.bindRotate($.proxy(this._onRotate, this));
    },
    _initVars: function(){
        this._nHeight = this._window.height();
        this._htOsInfo =  jindo.m.getOsInfo();
        this._nVersion = parseInt(this._htOsInfo.version, 10);
    },
    _checkHashParameter: function(key){
        var matches = window.location.hash.match(new RegExp(key+'=([^&]*)'));
        return matches ? matches[1] : null;
    },
    _onScrollStop: function(){
        this._checkViewport();
    },
    _onRotate: function(){
        this._resetImgMaps();
        this._initVars();
        this._checkOrientation();
        this._checkViewport();
    },
    _checkOrientation: function(){
        if(window.innerHeight > window.innerWidth) {
            this._sOrientation = 'landscape';
        } else {
            this._sOrientation = 'portrait';
        }
    },
    _checkViewport: function(){
        var oSelf = this,
            aTarget = this._getCurrentImgMaps();

        if(aTarget.length) {
            aTarget.rwdImageMaps(function(){
                if(oSelf._bDebug) {
                    oSelf._initDebugging(aTarget);
                }
            });
        }
    },
    _getCurrentImgMaps: function(){
        var nScrollTop = this._getScrollTop(),
            nMinTop = nScrollTop - this.htRatio[this._sOrientation] * this._nHeight,
            nMaxTop = nScrollTop + this._nHeight + this.htRatio[this._sOrientation] * this._nHeight;

        nMinTop = (nMinTop <= 0) ? 0 : nMinTop;

        return this._welImage.filter(function(){
           var $this = $(this);
           var nTargetTop = $this.offset().top;
           var nTargetBottom = nTargetTop+ $this.height();
           return ($this.data('rwdImage') !== 'T') && ((nMinTop <= nTargetTop) && (nTargetTop <= nMaxTop));
        });
    },
    _resetImgMaps: function(){
        var oSelf = this;

        if(this._bDebug){
            $('.canvasMapView').each(function() {
                oSelf._hideMapArea($(this)[0]);
            });
        }

        this._welImage.data('rwdImage', '');

        if(this._htOsInfo.android && this._nVersion < 3){
            this._welImage.css('textIndent', '0px');
        }
    },
    _getScrollTop: function(){
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    _initDebugging: function(aTarget){
        var oSelf = this,
            htImgMap = {
                target: null,
                id: null,
                usemap: null
            };

        $.each(aTarget, function(i, val){
            htImgMap.target = $(val);
            htImgMap.usemap = htImgMap.target.attr('usemap').substring(1);
            htImgMap.id = 'img' + htImgMap.usemap;
            htImgMap.target.attr('id', htImgMap.id);

            oSelf._buildCanvasMap(htImgMap.id);

            $('map[name="' + htImgMap.usemap + '"]').find('area').each(function() {
                oSelf._showMapArea($(this)[0], htImgMap.id);
            });
        });
    },
    _buildCanvasMap: function(sImgId){
        var img = document.getElementById(sImgId);
        var imgParent = img.parentNode;
        var x, y, w, h;
        x = img.offsetLeft;
        y = img.offsetTop;
        w = img.clientWidth;
        h = img.clientHeight;

        var canv = document.createElement('canvas');
        canv.id = 'canv' + sImgId;
        canv.classList.add('canvasMapView');

        if(!document.getElementById(canv.id)){
            imgParent.appendChild(canv);
        }

        var can = document.getElementById(canv.id);
        can.style.position = 'absolute';
        can.style.pointerEvents = 'none';
        can.style.zIndex = 1;
        can.style.left = x +'px';
        can.style.top = y +'px';
        can.setAttribute('width', w + 'px');
        can.setAttribute('height', h + 'px');

        var canvasContext = can.getContext('2d');
        canvasContext.fillStyle = 'red';
        canvasContext.strokeStyle = 'red';
        canvasContext.lineWidth = 2;
    },
    _drawPoly: function(coOrdStr, canvasContext){
        var mCoords = coOrdStr.split(',');
        var i, n;
        n = mCoords.length;

        canvasContext.beginPath();
        canvasContext.moveTo(mCoords[0], mCoords[1]);
        for (i = 2; i < n; i += 2) {
            canvasContext.lineTo(mCoords[i], mCoords[i+1]);
        }
        canvasContext.lineTo(mCoords[0], mCoords[1]);
        canvasContext.stroke();
    },
    _drawRect: function(coOrdStr, canvasContext){
        var mCoords = coOrdStr.split(',');
        var top, left, bot, right;
        var r_a = 0.3;

        left = mCoords[0];
        top = mCoords[1];
        right = mCoords[2];
        bot = mCoords[3];

        canvasContext.fillStyle = "rgba(32, 45, 21, " + r_a + ")";
        canvasContext.strokeRect(left,top,right-left,bot-top);
        canvasContext.fillRect(left,top,right-left,bot-top);
    },
    _drawCir: function(coOrdStr, canvasContext){
        var mCoords = coOrdStr.split(',');
        var x, y, r;

        x = mCoords[0];
        y = mCoords[1];
        r = mCoords[2];
        canvasContext.beginPath();
        canvasContext.arc(x, y, r, 0, 2 * Math.PI);
        canvasContext.stroke();
    },
    _showMapArea: function(element, imageMapId){
        var coordStr = element.getAttribute('coords');
        var areaType = element.getAttribute('shape');
        var canvasId = 'canv' + imageMapId;
        var canvas = document.getElementById(canvasId);
        var canvasContext = canvas.getContext('2d');

        switch (areaType){
            case 'polygon':
            case 'poly':
                this._drawPoly(coordStr, canvasContext);
                break;
            case 'rect':
                this._drawRect(coordStr, canvasContext);
                break;
            case 'circle':
                this._drawCir(coordStr, canvasContext);
        }
    },
    _hideMapArea: function(canvas){
        var context = canvas.getContext('2d');
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.beginPath();
    }
};

$(function(){
    if ($('.resmap').length) {
        var oSsgViewResponsiveImgMap = new ssg.View.responsiveImgMap({
            sMapImg: '.resmap'
        });
    }
});